import { render, staticRenderFns } from "./symbol.vue?vue&type=template&id=0f603df6&"
import script from "./symbol.vue?vue&type=script&lang=js&"
export * from "./symbol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports